import { withLocalState } from 'pyradux';
import EbayContainer from './Ebay.container';
import reducer from './Ebay.reducer';
import EbaySagas from './Ebay.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'ebay',
  sagas: [EbaySagas],
};

export default withLocalState(withLocalStateOptions, EbayContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/index.js